'use client';

import {
  AnalyticsEventName,
  getClientBrowserParameters,
  sendShopifyAnalytics,
  ShopifySalesChannel,
  useShopifyCookies,
} from '@shopify/hydrogen-react';
// import { usePathname, useSearchParams } from 'next/navigation';
import { Suspense, useEffect } from 'react';

import { COOKIE_CONSENT_CATEGORY } from '@/helpers/client/cookie-consent';
import { useStore } from '@/helpers/store';

import { CONFIG, SHOPIFY } from '@/config';

// const analyticsShopData = {
//   shopId: process.env.SHOPIFY_SHOP_ID,
//   shopifySalesChannel: ShopifySalesChannel.headless,
//   currency: SHOPIFY.currencyCode,
// };

// const sendShopifyPageViewAnalytics = (payload) => {
//   sendShopifyAnalytics(
//     {
//       eventName: AnalyticsEventName.PAGE_VIEW,
//       payload: {
//         ...getClientBrowserParameters(),
//         ...analyticsShopData,
//         ...payload,
//       },
//     },
//     process.env.SHOPIFY_SHOP_DOMAIN,
//   );
// };

export const sendShopifyAddToCartAnalytics = ({
  hasUserConsent,
  cartId,
  shopifyProduct,
  variant,
  quantity,
}) => {
  /**
   * @type {import('@shopify/hydrogen-react').ShopifyAnalyticsProduct}
   */
  const shopifyAnalyticsProduct = {
    productGid: shopifyProduct.id,
    variantGid: variant.id,
    name: shopifyProduct.title,
    variantName: variant.title,
    brand: CONFIG.name,
    price: variant.price.amount,
    quantity,
  };

  // sendShopifyAnalytics(
  //   {
  //     eventName: AnalyticsEventName.ADD_TO_CART,
  //     payload: {
  //       ...getClientBrowserParameters(),
  //       ...analyticsShopData,
  //       hasUserConsent,
  //       cartId,
  //       totalValue: parseFloat(variant.price.amount) * quantity,
  //       products: [shopifyAnalyticsProduct],
  //     },
  //   },
  //   process.env.SHOPIFY_SHOP_DOMAIN,
  // );
};

const Dynamic = ({ locale }) => {
  const [store] = useStore();

  // const pathname = usePathname();
  // const searchParams = useSearchParams();

  const hasUserConsent = !!store?.cookieConsent?.acceptedCategories?.includes(
    COOKIE_CONSENT_CATEGORY.STATISTICS,
  );

  useShopifyCookies({
    hasUserConsent,
    domain: process.env.DOMAIN,
  });

  // useEffect(() => {
  //   if (hasUserConsent) {
  //     sendShopifyPageViewAnalytics({
  //       hasUserConsent,
  //       canonicalUrl: pathname,
  //       acceptedLanguage: locale.shortCode,
  //     });
  //   }
  // }, [hasUserConsent, pathname, searchParams]);

  return null;
};

export const ShopifyTracking = ({ locale }) => {
  return (
    <Suspense>
      <Dynamic locale={locale} />
    </Suspense>
  );
};
